var types = {
	MessageId: "[u8;32]",
	ExitCode: "i32",
	Payload: "Vec<u8>",
	TypesRepr: {
		input: "Option<u32>",
		output: "Option<u32>"
	},
	ProgramMetadataReprRustV1: {
		init: "TypesRepr",
		handle: "TypesRepr",
		reply: "Option<u32>",
		others: "TypesRepr",
		signal: "Option<u32>",
		state: "Option<u32>",
		reg: "Vec<u8>"
	},
	ProgramMetadataReprRustV2: {
		init: "TypesRepr",
		handle: "TypesRepr",
		reply: "Option<u32>",
		others: "TypesRepr",
		signal: "Option<u32>",
		state: "TypesRepr",
		reg: "Vec<u8>"
	},
	StateMetadataRepr: {
		functions: "BTreeMap<String, TypesRepr>",
		reg: "Vec<u8>"
	}
};
var typesMetadata = {
	types: types
};

export { typesMetadata as default, types };
